import * as React from "react";
import { forwardRef } from "react";
const FogLightsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M6.424 5.254a.75.75 0 0 1 1.197.901l-.129.215a3.866 3.866 0 0 0-.369 1.014 2.792 2.792 0 0 0-.044.932l2.648-1.258a.75.75 0 1 1 .644 1.355L7.544 9.756c.134.665.071 1.339-.058 1.916l-.015.058 2.256-1.071a.75.75 0 0 1 .999.355.75.75 0 0 1-.355.999l-3.665 1.74a4.58 4.58 0 0 0-.092 1.041c.007.25.036.503.091.749l3.022-1.435a.75.75 0 0 1 .999.356.75.75 0 0 1-.355.999l-3.086 1.466c.24.742.091 1.488-.132 2.066-.279.723-.724 1.334-.954 1.641a.75.75 0 0 1-1.05.149.75.75 0 0 1-.149-1.05c.22-.293.555-.763.754-1.279.126-.328.176-.617.146-.869l-2.578 1.226-.071.029a.75.75 0 0 1-.573-1.384l2.651-1.26a5.27 5.27 0 0 1-.213-1.363v-.325l-1.794.852-.071.03a.75.75 0 0 1-.573-1.385l2.87-1.364a5.63 5.63 0 0 0 .476-1.3 3.62 3.62 0 0 0 .094-.909l-2.795 1.328a.75.75 0 0 1-.645-1.354l3.007-1.43c-.181-.67-.147-1.334-.029-1.899a5.16 5.16 0 0 1 .724-1.764l.046-.062z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.306 4.585c4.052 0 7.344 3.302 7.344 7.281 0 3.987-3.289 7.219-7.333 7.219h-.034a.75.75 0 0 1-.69-.458c-.783-1.854-1.242-4.215-1.242-6.765 0-2.576.469-4.959 1.267-6.822a.75.75 0 0 1 .689-.455zm.499 1.522c-.593 1.581-.955 3.573-.955 5.755 0 2.157.354 4.13.935 5.702 3.016-.235 5.364-2.715 5.364-5.698s-2.348-5.504-5.345-5.759z"
}));
const ForwardRef = forwardRef(FogLightsIcon);
export default ForwardRef;